import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FlashOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"flash_off"}/>
}
